import { useState } from 'react';
import { useIntl } from 'react-intl';

import ManageSyncPair from '~/components/Admin/IntegrationPage/ManageSyncPair/ManageSyncPair';
import { SearchInput } from '~/eds/src/components/SearchInput/SearchInput';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { IntegrationCards } from '~/features/integrations/IntegrationCards';
import { IntegrationFilters } from '~/features/integrations/IntegrationFilters';
import { EsignatureModal } from '~/features/integrations/modals/EsignatureModal';
import { MicrosoftWordIntegrationModal } from '~/features/integrations/modals/MicrosoftWordIntegrationModal';
import { SalesforceModal } from '~/features/integrations/modals/SalesforceModal';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { RoutePathType } from '~/routing/enums';
import { generateNav } from '~/routing/nav';
import { useRouting } from '~/routing/useRouting';

import DEPRECATED_Integrations from './DEPRECATED_index';

const Page = () => {
  const intl = useIntl();
  const { params } = useRouting();
  const { clientId } = params;

  const enableNewIntegrationPage = useFlag(FlagType.NewIntegrationsPage);

  const [search, setSearch] = useState<string>('');

  const nav = generateNav({
    current: {
      text: intl.formatMessage({
        id: 'DocumentManagement.navTitle',
        defaultMessage: 'Integrations',
        description: 'Document Management navigation title',
      }),
      pathname: RoutePathType.AdminConsoleClientIntegrations,
    },
    from: RoutePathType.AdminConsoleClient,
    params: {
      clientId: clientId,
    },
    intl,
  });

  if (!enableNewIntegrationPage) {
    return <DEPRECATED_Integrations />;
  }

  return (
    <>
      <PageLayout
        title={intl.formatMessage({
          id: 'Integrations.pageTitle',
          defaultMessage: 'Integrations',
          description: 'Integrations page title',
        })}
        nav={nav}
      >
        <SearchInput
          name="search"
          value={search}
          onChange={(value) => {
            setSearch(value ?? '');
          }}
        />
        <IntegrationFilters />
        <IntegrationCards search={search} />
      </PageLayout>
      <ManageSyncPair />
      <EsignatureModal />
      <SalesforceModal />
      <MicrosoftWordIntegrationModal />
    </>
  );
};

export default Page;
